import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import { URLS, APIS, SF_INTF_ORG_ENPO_INFO } from "./services/OsciIntfOrgEnpoMgmtService";
/*
 * Update Channel
 * !== 채널 수정 ==!
 */
export const OSCI0113006S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { orgEnpoId } = useParams();
    const [sndrcvDvnCd, setSndrcvDvnCd] = useState();
    const [govesbUseYn, setGovesbUseYn] = useState<boolean>(false);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0103" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "OSC0110" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "OSC0109" }, // 송수신 구분 코드
            { area: "comnCd", comnCd: "OSC0105" }, // 연계 프로토콜 코드
            { area: "comnCd", comnCd: "OSC0104" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "OSC0112" }, // 연계인증 유형 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        intfOrgEnpoForm: useForm({
            defaultSchema: SF_INTF_ORG_ENPO_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Channel !== 채널 정보 조회 ==!
        getIntfOrgEnpo: useFetch({
            api: () => APIS.getIntfOrgEnpo(orgEnpoId),
            enabled: !!orgEnpoId,
            onSuccess: (data) => {
                const intfOrgEnpo = data.intfOrgEnpoDto.content;

                setSndrcvDvnCd(intfOrgEnpo.sndrcvDvnCd);
                // 조회한 GOVESB 사용 여부를 화면 상태에도 반영해야 API Code, Push Code 가 표시된다.
                setGovesbUseYn(intfOrgEnpo.govesbUseYn === "Y");
                form.intfOrgEnpoForm.setValues(intfOrgEnpo);
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {},
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.osc.00035" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
        // Update Channel !== 채널 수정 ==!
        updateIntfOrgEnpo: useFetch({
            api: (data) => APIS.updateIntfOrgEnpo({ ...data }),
            onSuccess: (res) => {
                modal.openModal({
                    content: "msg.osc.00073", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        const orgEnpoId = res.intfOrgEnpo.content.orgEnpoId;
                        fetch.getIntfOrgEnpo.fetch(orgEnpoId);
                    },
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.intfOrgEnpoForm.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.osc.00015", // An error occurred during processing.
                });
            },
        }),
        // delete channel !== 채널 삭제 ==!
        deleteIntfOrgEnpo: useFetch({
            api: () => APIS.deleteIntfOrgEnpo(orgEnpoId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.osci0113004q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 문서함 수정 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.intfOrgEnpoForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.intfOrgEnpoForm.handleSubmit(
                () => {
                    const data = form.intfOrgEnpoForm.getValues();
                    // Check the reason for rejection when returning a product !== 반려 시 반려사유 체크  ==!
                    if (data.chnlAplyPrcdStatCd === "D" && comnUtils.isEmpty(data.rtrnRsn)) {
                        toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                        form.intfOrgEnpoForm.setFocus("rtrnRsn");
                        return;
                    }

                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateIntfOrgEnpo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteIntfOrgEnpo.fetch();
                },
            });
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"L_ORG_ENPO_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.intfOrgEnpoForm.schema.sndrcvDvnCd}
                                onChange={(value) => {
                                    form.intfOrgEnpoForm.clearErrors();

                                    if (comnUtils.isEmpty(sndrcvDvnCd)) {
                                        setSndrcvDvnCd(value);
                                    } else if (sndrcvDvnCd !== value) {
                                        modal.openModal({
                                            // All entered information will be reset. Do you want to change it?. !== 입력한 정보가 모두 초기화됩니다. 변경하시겠습니까?. ==!
                                            content: "msg.osc.00117",
                                            onConfirm: () => {
                                                form.intfOrgEnpoForm.reset();

                                                form.intfOrgEnpoForm.setValue("sndrcvDvnCd", value);
                                                setSndrcvDvnCd(value);
                                            },
                                            onCancel: () => {
                                                form.intfOrgEnpoForm.setValue("sndrcvDvnCd", sndrcvDvnCd);
                                                setSndrcvDvnCd(sndrcvDvnCd);
                                            },
                                        });
                                    }
                                }}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgEnpoId} edit={false} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgEnpoNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgCd} readOnly={true} />
                            {/* <Group.Control {...form.intfOrgEnpoForm.schema.orgTin} /> */}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgIpAddr} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgPortNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.orgUrlAddr} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_IFAUTH_INFO"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.intfOrgEnpoForm.schema.govesbUseYn}
                                onChange={(value) => {
                                    setGovesbUseYn(value == "Y");
                                }}
                            />
                        </Group.Row>
                        {govesbUseYn && (
                            <Group.Row>
                                <Group.Control {...form.intfOrgEnpoForm.schema.apiCd} />
                                <Group.Control {...form.intfOrgEnpoForm.schema.pushCd} />
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknTpCd} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknUrlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknId} />
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknPwd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.tknCn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.signFileId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.signKeyCn} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.rspnSignFileId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoForm.schema.rspnSignKeyCn} controlSize={10} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0113004q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.onDeleteBtnClick();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
